import { Typography } from '@mui/material';
import { TokenFormat } from 'shared';

interface BalanceProps {
  balance: string | bigint | undefined;
  currency: string;
  decimals: number;
}

export const Balance = ({ balance, currency, decimals }: BalanceProps) => {
  return (
    <Typography variant="body1" className="secondary">
      Balance:{' '}
      <TokenFormat
        component="span"
        variant="inherit"
        color="white"
        amount={balance}
        decimals={decimals}
        symbol={currency}
        fallback={`0.00 ${currency}`}
      />
    </Typography>
  );
};
